export const subscriptionStatus = {
  IN_TRIAL: 'trial',
  TRIAL_EXPIRED: 'trial_expired',
  UNPAID: 'unpaid',
};
